import { render, staticRenderFns } from "./PurchaseDetails.vue?vue&type=template&id=c5c9a338&scoped=true&lang=html&"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c9a338",
  null
  
)

export default component.exports